var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCacheItem, setCacheItem } from '../cache';
import { getRequestId, updateRequest } from '../dataLayer';
import { doWhenP } from '../utils';
const CACHE_KEY = 'pushlyData';
export function getPushlyData() {
    var _a;
    const user = (_a = window === null || window === void 0 ? void 0 : window.PushlySDK) === null || _a === void 0 ? void 0 : _a.getUser();
    const puid = (user === null || user === void 0 ? void 0 : user.getId()) || null;
    return { puid };
}
function sendPushlyData(requestId) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = getPushlyData();
        const cache = getCacheItem(CACHE_KEY) || {};
        const pushly = Object.assign(Object.assign({}, data), { requestId });
        if (!data.puid || (cache.requestId === requestId && cache.puid === data.puid))
            return;
        updateRequest(requestId, { pushly }).then(() => {
            setCacheItem(CACHE_KEY, pushly);
        });
    });
}
function pushlyPredicate() {
    return !!(getRequestId() && window.PushlySDK && window.PushlySDK.getUser);
}
export function run() {
    return __awaiter(this, void 0, void 0, function* () {
        doWhenP(pushlyPredicate, 15000)
            .then(() => sendPushlyData(getRequestId()))
            .catch(e => {
            console.log('pushly update request failed: ', e);
        });
    });
}
//# sourceMappingURL=pushlyData.js.map